import { useContext } from 'react';
import { BdmLciConfigContext } from '../providers/BdmLciConfigProvider';
function useBdmLciConfig() {
    return useContext(BdmLciConfigContext);
}
export default useBdmLciConfig;
